import { Routes } from '@angular/router';

export const authRoutes: Routes = [
  {
    path: 'register',
    loadComponent: () => import('../pages/register/register.component'),
  },
  {
    path: 'registro',
    loadComponent: () => import('../pages/register/register.component'),
  },
];
